<template>
  <component
    :is="href ? 'a' : 'button'"
    :href="href"
    :class="['rct-btn', `rct-btn--${variant ?? 'primary'}`]"
    :disabled="disabled || loading"
    v-bind="$attrs"
  >
    <span v-if="loading" class="rct-btn__spinner" aria-hidden="true" />
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{ variant?: 'primary' | 'ghost'; href?: string; disabled?: boolean; loading?: boolean; }>();
</script>

<style scoped>
.rct-btn { font-family: 'Space Grotesk', sans-serif; font-weight: 600; font-size: 0.9rem; letter-spacing: 0.04em; padding: 0.9rem 2.25rem; border-radius: 3px; border: none; cursor: pointer; text-decoration: none; display: inline-flex; align-items: center; gap: 0.5rem; transition: background 0.2s, transform 0.15s, color 0.2s; }
.rct-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.rct-btn--primary { background: #7a96c1; color: #091a38; }
.rct-btn--primary:hover:not(:disabled) { background: #e1ecff; transform: translateY(-1px); }
.rct-btn--ghost { background: transparent; color: #7a96c1; border-bottom: 1px solid #1a3a6e; padding: 0 0 2px; border-radius: 0; }
.rct-btn--ghost:hover:not(:disabled) { color: #e1ecff; border-color: #7a96c1; }
.rct-btn__spinner { width: 14px; height: 14px; border: 2px solid currentColor; border-top-color: transparent; border-radius: 50%; animation: spin 0.6s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
